(ns practitest.frontend.forms3.milestone
  (:require
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.common.permissions :as permissions]
    [practitest.frontend.common.re-frame :refer [partial-dispatch]]
    [practitest.frontend.common-entities.events :as common-events]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.forms3.entity-form :as f3.entity-form]
    [practitest.frontend.forms3.entity-form.forms :as f3.forms]
    [practitest.frontend.forms3.entity-form.utils :refer [track!]]
    [practitest.frontend.milestone.events :as milestone-events]
    [practitest.frontend.routing.router :as router]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]))

(def ^:private milestone-form-id :milestone-main)
(def edit-permission "milestones_editor")
(def delete-permission "milestones_admin")

(defn milestone-menu []
  (let [milestone (:current @(re-frame/subscribe [::subs/entity :milestone]))
        {:keys [id]} milestone]
    [{:id (str "milestone-" id "-delete")
      :text (get-translation "generic.button.delete" "Delete")
      :icon [icons/mux-trash]
      :on-click (fn [e]
                  (dom/prevent-default e)
                  (track! "Delete entity" :milestone)
                  (when (js/confirm (get-translation "entity.confirm.action-delete" "Are you sure? This Operation cannot be undone."))
                    (re-frame/dispatch [::milestone-events/delete id])))}]))

(defn- form-layout-milestone
  [entity-fields]
  (let [nil-or-unavailable? (fn [field]
                           (or (nil? field)
                               (not (contains? entity-fields field))))

        initial-layout {:title {:fields [{:field :name}] }
                        (:description f3.entity-form/sections-keys) {:fields [{:field :description}]}}

        existing-fields (set (f3.forms/flatten-layout initial-layout))
        to-remove? (fn [field]
                     (or (nil-or-unavailable? field)
                         (contains? existing-fields field)))

        filtered-entity-fields (f3.entity-form/filter-entity-fields entity-fields to-remove?)
        filtered-entity-fields-flat (vec (keys filtered-entity-fields))
        entity-sections @(re-frame/subscribe [::subs/entity-sections :milestone])

        update-main-sections (if (some? entity-sections)
                               #(f3.entity-form/update-layout % entity-sections filtered-entity-fields)
                               #(f3.entity-form/update-layout % (:general-info f3.entity-form/sections-keys) filtered-entity-fields-flat "general_info" entity-fields))

        layout (-> initial-layout
                   (update-main-sections))]
    layout))

(defmethod f3.forms/build-entity-form-layout milestone-form-id
  [_ _ _ entity-fields _]
  (form-layout-milestone entity-fields))

(defn main [new? tabs]
  [f3.entity-form/entity-form
   {:new?              new?
    :popup-menu        (when (permissions/has-permission? delete-permission) (milestone-menu))
    :on-save           (partial-dispatch [::common-events/save-entity milestone-form-id :milestone])
    :entity-type       :milestone
    :form-id           milestone-form-id
    :breadcrumbs       [{:href  (router/get-href :practitest.frontend.milestones/index {:project-id (:id @(re-frame/subscribe [::subs/current-project]))})
                         :label (get-translation "navigation.project-menu.milestones" "Milestones")}]
    :header-tabs       tabs
    :edit-permissions? (permissions/has-permission? edit-permission)
    :customization-permissions? (permissions/has-permission? "customization")
    :general-form-inner-tabs {:new #{:attachments}
                              :edit #{:attachments :comments}}
    :default-active-sub-tab :attachments}])
